<template>
  <div class="home-container">
    <div class="box has-background-white-ter no-border-print shared-error" v-if="shareNotFound">
      <DoodleMessage :message="doodleForm.errorMessage" message-class="has-text-danger"
                     v-show="doodleForm.errorMessage"/>
    </div>
    <div class="box main-box no-border-print" v-if="!shareNotFound">
      <div class="has-text-right toggle-section">
          <div class="field is-paddingless is-marginless">
              <label class="has-text-weight-semibold auto-save-text toggle-java">Java</label>
              <a>
                <input id="autoSave"  v-model="isCSharp"  value="false" type="checkbox" name="autosaveon" class="switch lang-toggle" @change="onLanguageChange"/>&nbsp;&nbsp;
                <label for="autoSave" class="has-text-weight-semibold auto-save-text has-text-white"></label>
              </a>
              <label class="has-text-weight-semibold auto-save-text has-text-white">C#</label>
              <a class="clipboard-link" @click="copyToClipboard">
                <img :src="clipboardImage" class="clipboard">
              </a>

          </div>
      </div>
      <div>
        <div id="code" class="code-editor no-border-print"></div>
      </div>
      <div class="execute-section" v-if="!hideExecute">
        <div id="files-menu" role="menu" v-if="inputFiles.length>0 && showFilesMenu"  @mouseenter="showFilesMenu=true" @mouseleave="showFilesMenu=false">
          <div class="dropdown-content">
            <div class="dropdown-item has-text-left">
              <div v-for="file in inputFiles" v-bind:key="fileEditor" class="folder-note has-text-weight-semibold">
                <a class="is-link has-text-weight-semibold has-text-dark" @click.prevent="removeFile(file)"><font-awesome-icon icon="times-circle"/></a>&nbsp;&nbsp;
                <a class="is-link has-text-weight-semibold has-text-dark is-underlined" :href="getInputUrl(file)" target="_blank">/uploads/{{file}}</a>
              </div>
            </div>
          </div>
        </div>
        <span class="has-text-centered little-margin" v-if="uploadInProgress">
          <button class="button execute-button is-rounded has-text-white" @click="cancelUpload">
            <font-awesome-icon icon="stop-circle"/>&nbsp;&nbsp;Cancel Upload
          </button>
        </span>
        <label class="button execute-button is-rounded has-text-white is-right" id="upload-button" v-if="!uploadInProgress" @mouseenter="showFilesMenu=true" @mouseleave="showFilesMenu=false">
          <input class="file-input upload-pointer" type="file" name="file" @change="tryUploadFile($event)" title="">
          <font-awesome-icon icon="cloud-upload-alt"/>&nbsp;&nbsp;Upload File&nbsp;&nbsp;
          <span class="tag has-background-white count-tag" aria-haspopup="true" aria-controls="dropdown-menu4" v-if="inputFiles.length>0">{{inputFiles.length}}</span>
        </label>
        <button class="button execute-button is-rounded has-text-white is-right" @click="tryExecute">
          <span v-show="!isCodeExecuting"><font-awesome-icon icon="play"/>&nbsp;&nbsp;&nbsp;Execute</span>
          <span v-if="isCodeExecuting">
            <font-awesome-icon icon="spinner" class="fa-spin"/>&nbsp;&nbsp;&nbsp;Executing...</span>
        </button>
        <div v-if="uploadInProgress">
          <font-awesome-icon icon="spinner" class="fa-spin"/>
          <span class="upload-inprogress-message has-text-weight-semibold upload-message"> Upload in Progress, Please wait... </span>
        </div>
        <div  v-show="uploadMessage" class="upload-message">
           {{uploadMessage}}
        </div>
      </div>
      <div v-show="showOutput">
        <div class="has-text-weight-semibold ide-title" v-show="outputFiles && outputFiles.length>0">Files Generated</div>
        <div v-for="file in outputFiles" v-bind:key="fileEditor" class="folder-note has-text-weight-semibold">
          <button class="has-text-weight-semibold is-size-7 has-text-link is-underlined button-reset" @click="getUrl(file)">{{file}}</button>
        </div>
        <div class="has-text-weight-semibold ide-title">Output</div>
        <div>
          <div id="output" class="code-editor no-border-print"></div>
        </div>
      </div>
      <div id="ideContainer" class="g-recaptcha is-hidden-print margin-top-20px has-text-centered is-hidden" data-size="invisible" data-sitekey="6LfPlOsUAAAAAIALEFUM1022nNwsyWjpATeuYMdi" data-badge="inline"></div>
    </div>
  </div>
</template>

<script>
import aceMixin from './../assets/javascript/ide-mixin'
import { IDE_CONST, ROBOT_CONST } from '../assets/javascript/constants'
import DoodleMessage from '../components/Utils/DoodleMessage'
import formMixin from './../assets/javascript/form-mixin'
import { META } from '../assets/javascript/meta'
import loadScriptInBody from '../assets/javascript/loadScriptInBody'
import jqueryFileUpload from 'jquery-simple-upload'
import recaptchaMixin from '../assets/javascript/recaptcha-mixin'

const jdoodleItextId = 'jdoodle-itext-id'

export default {
  name: 'embedIText',
  components: { DoodleMessage },
  mixins: [aceMixin, formMixin, recaptchaMixin],
  data: function () {
    return {
      interactiveModeOption: false,
      project: null,
      autoSaveOn: false,
      ideMeta: {},
      shareNotFound: false,
      isCSharp: false,
      pymChild: null,
      showOutput: false,
      javaLibs: ['com.itextpdf:itext7-core:7.1.6', 'org.slf4j:slf4j-api:1.7.28', 'org.slf4j:slf4j-simple:1.7.28'],
      csharpLibs: ['itext7:7.1.8'],
      showUpload: false,
      hideExecute: false,
      uploadInProgress: false,
      currentUpload: null,
      uploadMessage: null,
      inputFiles: [],
      maxUploads: 10,
      maxFileSize: 5000000,
      maxFileErrorCode: 'MAXIMUM_UPLOAD_SIZE_EXCEEDED',
      showFilesMenu: false,
      uploadEvent: null
    }
  },
  mounted () {
    if (this.$store.state.robotChecked === false) {
      this.loadRecaptcha('ideContainer', this.doRoboCheck)
    }

    this.isEmbed = true
    this.interactiveMode = true

    this.initSession()

    this.ideMeta = META['java']
    window._.delay(this.initEditors, 500, 1)
    let postAceAction = (count) => {
      if (window.ace) {
        this.pymChild = new pym.Child()

        this.pymChild.onMessage('setScript', (data) => {
          data = JSON.parse(data)
          if (data.id === this.$route.query.id) {
            this.initScripts(data)
          }
        })

        this.javaLibraries = this.javaLibs
        this.pymChild.sendMessage('getScript', JSON.stringify({ id: this.$route.query.id }))
      } else if (count < 20) {
        window._.delay(postAceAction, 600, count + 1)
      }
    }
    let postAction = (count) => {
      if (window.pym) {
        window.pym.Child({ polling: 500 })
        window._.delay(postAceAction, 100, 1)
      } else if (count < 20) {
        window._.delay(postAction, 600, count + 1)
      }
    }

    window._.delay(postAction, 600, 1)
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      loadScriptInBody.loadScriptInBody('/assets/javascript/ace.min.js')
        .then(() => {
          loadScriptInBody.loadScriptInBody('/assets/javascript/ext-language_tools.js')
          loadScriptInBody.loadScriptInBody('/assets/javascript/ext-static_highlight.js')
        })
      loadScriptInBody.loadScriptInBody('/assets/jdoodle-pym.min.js')
    })
    next()
  },
  beforeRouteLeave (to, from, next) {
    if (window.confirm('Do you want to leave ' + this.ideMeta.langDisplayName + ' IDE?')) {
      next()
    } else {
      next(false)
    }
  },
  computed: {
    language () {
      return this.ideMeta.language
    },
    aceLanguageCode () {
      return this.ideMeta.aceCode ? this.ideMeta.aceCode : this.ideMeta.language
    },
    isCompileLang () {
      return true
    },
    clipboardImage () {
      return require('../assets/images/clippy.svg')
    }
  },
  methods: {
    initSession: function () {
      let url = '/api/doodle/initItext'
      let data = {}
      $.ajax({
        type: 'POST',
        url: url,
        data: JSON.stringify(data),
        contentType: "application/json"
      }).done((data) => {
        if (data.robotChecked === true) {
          this.$store.commit('robotCheckDone')
        }
        $.ajaxSetup({
          headers: { 'Kurukku-Kuri': data.kurukkuKuri }
        })
        sessionStorage.setItem(jdoodleItextId, data.jdid)
        this.inputFiles = data.inputFiles
      }).fail((jqXHR, textStatus, errorThrown) => {
        // error handling
      })
    },
    getUrl (file) {
      const link = document.createElement('a')
      link.href = `/api/projectSync/downloadItem?projectKey=1001&name=${encodeURIComponent(file)}&type=output`
      link.download = file
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    getInputUrl (file) {
      return `/api/projectSync/downloadItem?projectKey=1001&name=/${encodeURI(file)}&type=input`
    },
    cancelUpload () {
      this.currentUpload.cancel()
    },
    copyToClipboard () {
      window.navigator.clipboard.writeText(window.ace.edit(IDE_CONST.CODE_EDITOR).getSession().getValue())
    },
    postExecuteSuccessHandling () {

    },
    initScripts (data) {
      this.project = data

      if (this.project.javaUrl) {
        this.getScriptFromGithub(this.project.javaUrl, 'java')
      }

      if (this.project.csharpUrl) {
        this.getScriptFromGithub(this.project.csharpUrl, 'csharp')
      }

      if (this.project.javaLibs) {
        this.project.javaLibs = this.project.javaLibs.split(',')
      } else {
        this.project.javaLibs = this.javaLibs
      }

      if (this.project.csharpLibs) {
        this.project.csharpLibs = this.project.csharpLibs.split(',')
      } else {
        this.project.csharpLibs = this.csharpLibs
      }

      if (this.project.showUpload === 'true') {
        this.showUpload = true
      }

      if (this.project.hideExecute === 'true') {
        this.hideExecute = true
      }

      if (this.project.maxUploads) {
        this.maxUploads = this.project.maxUploads
      }

      if (this.project.maxFileSize) {
        this.maxFileSize = this.project.maxFileSize
      }

      this.onLanguageChange()
    },
    tryUploadFile (event) {
      this.uploadEvent = event
      this.callViaCaptcha(this.uploadFile, () => { this.doodleForm.errorMessage = ROBOT_CONST.ROBOT_ERROR })
    },
    uploadFile () {
      if (this.inputFiles.length >= this.maxUploads) {
        this.uploadMessage = 'Maximum upload limit reached.'
        _.delay(() => { this.uploadMessage = null }, 5000)
        return
      }

      if (this.uploadEvent.target.files[0].size >= this.maxFileSize) {
        this.uploadMessage = 'File exceeds the acceptable size.'
        _.delay(() => { this.uploadMessage = null }, 5000)
        return
      }

      let vm = this
      $(this.uploadEvent.target).simpleUpload('/api/projectSync/uploadInputFile', {
        data: { projectKey: 1001 },

        start: function (file) {
          vm.currentUpload = this.upload
          vm.uploadInProgress = true
        },

        progress: (progress) => {
        },

        success: (data) => {
          this.inputFiles = data.inputFiles
          this.uploadMessage = 'Upload successful'
          _.delay(() => { this.uploadMessage = null }, 5000)
          this.uploadInProgress = false
        },

        cancel: () => {
          this.uploadMessage = 'Upload Canceled'
          _.delay(() => { this.uploadMessage = null }, 5000)
          this.uploadInProgress = false
        },

        error: (error) => {
          if (error.xhr.status === 403) {
            this.clearRobotCheckStatus()
          }
          this.uploadMessage = error.message
          try {
            if (error.xhr.status === 400 && error.xhr.responseJSON.errorCode === this.maxFileErrorCode && error.xhr.responseJSON.errors.length > 0) {
              this.uploadMessage = error.xhr.responseJSON.errors[0]
            }
          } catch (e) {
            this.uploadMessage = error.message
          }
          _.delay(() => { this.uploadMessage = null }, 5000)
          this.uploadInProgress = false
        }

      })
    },
    getScriptFromGithub (url, targetScript) {
      $.ajax({
        type: 'get',
        url: url,
        headers: null
      }).done((data) => {
        if (targetScript === 'java') {
          this.project.javaScript = data
          if (this.project.javaReplaceThis) {
            this.project.javaReplaceThis = JSON.parse(this.project.javaReplaceThis)
            this.project.javaReplaceWith = JSON.parse(this.project.javaReplaceWith)

            for (let x in this.project.javaReplaceThis) {
              let re = new RegExp(this.project.javaReplaceThis[x], 'g')
              this.project.javaScript = this.project.javaScript.replace(re, this.project.javaReplaceWith[x])
            }
          }
        } else {
          this.project.csharpScript = data
          if (this.project.csharpReplaceThis) {
            this.project.csharpReplaceThis = JSON.parse(this.project.csharpReplaceThis)
            this.project.csharpReplaceWith = JSON.parse(this.project.csharpReplaceWith)

            for (let x in this.project.csharpReplaceThis) {
              let re = new RegExp(this.project.csharpReplaceThis[x], 'g')
              this.project.csharpScript = this.project.csharpScript.replace(re, this.project.csharpReplaceWith[x])
            }
          }
        }

        this.onLanguageChange()
      }).fail((jqXHR, textStatus, errorThrown) => {
        // error handling
      })
    },
    removeFile (file) {
      let url = '/api/projectSync/deleteInputFile'
      let data = { projectKey: 1001, name: file }
      $.ajax({
        type: 'POST',
        url: url,
        data: JSON.stringify(data),
        contentType: "application/json"
      }).done((data) => {
        this.inputFiles.splice(this.inputFiles.indexOf(file), 1)
      }).fail((jqXHR, textStatus, errorThrown) => {
        // error handling
      })
    },
    onLanguageChange () {
      this.outputFiles = []
      this.showOutput = false
      if (this.isCSharp) {
        this.ideMeta.language = 'itextcsharp'
        this.javaLibraries = this.project.csharpLibs
        window.ace.edit(IDE_CONST.CODE_EDITOR).getSession().setValue(this.project.csharpScript)
      } else {
        this.ideMeta.language = 'java'
        this.javaLibraries = this.project.javaLibs
        window.ace.edit(IDE_CONST.CODE_EDITOR).getSession().setValue(this.project.javaScript)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../node_modules/bulma-switch/dist/css/bulma-switch.min.css";
  @import "./../assets/style/ide";

  .home-container {
    margin: 1em;
    background: #F2F2F2;
  }

  .main-box {
    padding: 0.5em 1.2em;
    background: #F2F2F2;
  }

  .ide-title, .switch[type=checkbox] + label.ide-title {
    font-size: 0.9em;
    margin-top: 1em;
  }

  .column {
    padding-top: 0.15em;
    padding-bottom: 0.10em;
  }

  .execute-section {
    text-align: right;
    margin-right: 3%;
    position: relative;
  }

  .interactive-mode-top {
    margin-top: 0.75em;
  }

  .embed-brand-area {
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .info-text {
    font-size: 0.85em;
    color: black;
    font-weight: 500;
  }

  .powered-by {
    vertical-align: bottom;
  }

  #code {
    min-height: 10px;
  }

  .execute-button {
    background: #F99D25;
  }

  #code .ace-tomorrow-night .ace_gutter, .toggle-java {
    color: #F99D25;
  }

  .switch[type=checkbox]:checked+label::before, .switch[type=checkbox]:checked+label:before {
    background: #F99D25;
  }

  .switch[type=checkbox]+label::before, .switch[type=checkbox]+label:before {
    background: #F99D25;
  }

  .toggle-section {
    background: #1D1F21;
    padding: 5px;
  }

  .clipboard {
    width: 15px;
    height: 15px;
  }

  .clipboard-link {
    padding: 5px;
    background: #F99D25;
    margin-left: 10px;
  }

  .upload-pointer {
    cursor: pointer;
  }

  .upload-message {
    color: #F99D25;
  }

  .count-tag {
    color: #F99D25;
    font-weight: bold;
    border-radius: 20px;
  }

  #files-menu {
    position: absolute;
    right: 120px;
    bottom: 35px;
    vertical-align: top;
    z-index: 9999;
  }

  .folder-note {
    word-break: break-all;
  }

  .button-reset {
    background: none;
    border: none;
    box-shadow: none;
  }

</style>
